import { render } from "./indicadorIA.vue?vue&type=template&id=3f113e00&scoped=true"
import script from "./indicadorIA.vue?vue&type=script&lang=js"
export * from "./indicadorIA.vue?vue&type=script&lang=js"

import "./indicadorIA.vue?vue&type=style&index=0&id=3f113e00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f113e00"]])

export default __exports__